/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-danger */
import { useEffect, useState, useRef } from 'react';

import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { Link as Slink } from 'react-scroll';
import Slider from 'react-slick';
import { Container, Modal, ModalBody } from 'reactstrap';
import { useRecoilState, useRecoilValue } from 'recoil';

import { fetchProductLists } from '../../apis/products';
import Layout from '../../components/layout/layout';
import RestrictedPageLoader from '../../components/loader/restrictedpage';
import { productImpression, viewItemList } from '../../helpers/analytics';
import { videoPlayedEvent, freeSmileAssessmentClicked, seeHowItWorksClicked, watchTheVideoClicked,
  getFreeAssessmentClicked, eligibilityClicked, learnAboutPricingClicked, treatmentPlanClicked,
  startFreeAssessmentClicked } from '../../helpers/segment';
import useI18n from '../../hooks/use-i18n';
import { languages, contentLanguageMap, countryMap } from '../../language.config';
import { alignerLandingPageCountries, obt3EnabledMarkets } from '../../links.config';
import { config } from '../../recoil/atoms/config';
import { products } from '../../recoil/atoms/products';
import { cartPrice } from '../../recoil/selectors/cart';
import { productListsData } from '../../recoil/selectors/productLists';
import { sponsorCompanyList, sponsorSlider,
  cardSlider, paymentMethodMap, animatedIBBannerEnabledMarkets, animatedIBBannerCta2Links,
  beforeAfterImages, clinicLocations,
  jpHkClinicLocations, multilangcountries, beforeAfterImagesVn } from '../../utils/aligners.config';
import getTranslationKeys, { PAGEID } from '../../utils/i18nRosseta';
import { useUtmParam as useUtmData, customEventParam, analyticProductDataConfig2,
  DEFAULT_INVISIBLE_BRACES_PAGE_BANNERS } from '../../utils/utils';

import '../../styles/revamp/modal-style.scss';
import '../../styles/revamp/aligners.scss';
import '../../styles/home-revamp.scss';

const Collapse = dynamic(() => import('../../components/includes/collapse'), { ssr: false });
const Popover = dynamic(() => import('../../components/inputs/popover-table'), { ssr: false });
const BeforeAfterImage = dynamic(() => import('../../components/revamp/before-after-image'), { ssr: false });
const AlignerPageCard = dynamic(() => import('../../components/revamp/aligner-page-card'), { ssr: false });
const ClinicLocationsCollapse = dynamic(
  () => import('../../components/revamp/clinic-locations-collapse'), { ssr: false }
);

const InvisibleBraces = () => {
  const i18n = useI18n();
  const codes = i18n.activeLocale.split('-');

  const zenyumClearExtraEnabledMarkets = ['sg', 'hk', 'tw', 'vn'];

  const country = codes.length === 2 ? codes[0] : 'sg';
  const lang = codes[1] || 'en';
  const pageMetaData = i18n.t('metadata').aligner;
  const alignerPage = i18n.t('aligner_category_page');
  const faqData = Object.values(i18n.t('faqs'));
  const cartPriceDetails = useRecoilValue(cartPrice);
  const productData = useRecoilValue(products);
  const [productListData, setProductListData] = useRecoilState(productListsData);
  const router = useRouter();
  const query = router && router.query;
  const [isMobile, setIsMobile] = useState(false);
  const [modal, setModal] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);
  const paymentSlider = useRef(null);
  const configData = useRecoilValue(config);

  const paymentsSliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    arrows: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    beforeChange: (current, next) => setActiveSlide(next),
    responsive: [
      {
        breakpoint: 1056,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false
        }
      }
    ]
  };
  const [utmParams, setUtmParams] = useState('');
  const rightArr = alignerPage.aligner_comparison.zenyum_clear.data.length;

  function valueChange() {
    setIsMobile(window.innerWidth < 768);
  }

  useEffect(() => {
    if (alignerLandingPageCountries.includes(country)) {
      router.replace(`/${i18n.activeLocale}/`);
    }
  }, []);

  useEffect(() => {
    valueChange();
  }, []);

  useEffect(() => {
    if (cartPriceDetails) { sendTrackingEvent(); }
  }, [cartPriceDetails]);

  useEffect(() => {
    setTimeout(() => {
      setUtmParams(useUtmData('Invisible%20Braces%20Page'));
    }, 50);
  }, [query]);

  const getMaxHeight = () => {
    let maxHeight = 0;
    const cardTexts = document.querySelectorAll('.card-top');
    cardTexts.forEach((text) => {
      // eslint-disable-next-line no-param-reassign
      text.style.minHeight = 0;
    });
    cardTexts.forEach((text) => {
      if (text.offsetHeight > maxHeight) {
        maxHeight = text.offsetHeight;
      }
    });
    cardTexts.forEach((text) => {
      // eslint-disable-next-line no-param-reassign
      text.style.minHeight = `${maxHeight}px`;
    });
  };

  const setMinimumHeightPaycard = () => {
    const paycardClassNames = ['paycard-section-1', 'paycard-section-2', 'paycard-section-3'];
    paycardClassNames.forEach((element) => {
      const elements = document.getElementsByClassName(element);
      let minHeight = 0;
      // Reset the previous card height
      for (let i = 0; i < elements.length; i += 1) {
        elements[i].style.minHeight = '0px';
      }
      // Find the maximum height among elements with the same class name
      for (let i = 0; i < elements.length; i += 1) {
        const elementHeight = elements[i].offsetHeight;
        minHeight = Math.max(minHeight, elementHeight);
      }
      // Set the minimum height for all elements with the same class name
      for (let i = 0; i < elements.length; i += 1) {
        elements[i].style.minHeight = `${minHeight}px`;
      }
    });
  };

  useEffect(() => {
    setTimeout(() => {
      setMinimumHeightPaycard();
      getMaxHeight();
    }, 200);
    window.addEventListener('resize', getMaxHeight);
    window.addEventListener('resize', setMinimumHeightPaycard);
    return () => {
      window.removeEventListener('resize', getMaxHeight);
      window.removeEventListener('resize', setMinimumHeightPaycard);
    };
  }, [i18n.activeLocale]);

  const sendTrackingEvent = () => {
    const impressions = [{
      name: 'Zenyum Invisible Braces',
      id: 'ZENYUM_ALIGNERS',
      price: '2400',
      brand: 'Zenyum',
      category: 'Zenyum Clear',
      variant: 'DEFAULT'
    }];
    productImpression(cartPriceDetails.currency_code, impressions);
  };

  const getProductLists = async () => {
    if (!productListData.AlignerPageFavourites) {
      const recommendations = await fetchProductLists(['AlignerPageFavourites']);
      if (recommendations) setProductListData({ AlignerPageFavourites: recommendations });
    }
  };

  useEffect(() => {
    if (productListData?.AlignerPageFavourites && productListData?.AlignerPageFavourites.length) {
      const data = analyticProductDataConfig2(productListData?.AlignerPageFavourites);
      viewItemList(data.productList, data.currencyCode, 'invisible_braces_recommendation');
    }
  }, [productListData.AlignerPageFavourites]);

  useEffect(() => {
    if (Object.keys(productData).length > 0) {
      getProductLists();
    }
    // toggleIsAccountMenuOpen(true);
  }, [productData]);

  const toggle = () => {
    setModal(!modal);
    setTimeout(() => {
      if (modal) videoPlayedEvent('invisible_braces', countryMap[country]);
    }, 100);
  };

  const videosection = () => {
    toggle();
    watchTheVideoClicked(countryMap[country], 'Smile transformations made easy');
  };

  const bannerDesktop = configData?.banners?.alignerDesktop
  && configData.banners.alignerDesktop.length > 0
    ? configData.banners.alignerDesktop[0] : {
      bannerUrl: DEFAULT_INVISIBLE_BRACES_PAGE_BANNERS[country].desktop
    };
  const bannerMobile = configData?.banners?.alignerMobile
  && configData.banners.alignerMobile.length > 0
    ? configData.banners.alignerMobile[0] : {
      bannerUrl: DEFAULT_INVISIBLE_BRACES_PAGE_BANNERS[country].mobile
    };

  const obtBaseUrl = obt3EnabledMarkets.includes(country) ? process.env.NEXT_PUBLIC_OBT3_LINK
    : process.env.NEXT_PUBLIC_OBT_LINK;

  return (
    <Layout
      page="shop_aligner"
      description={pageMetaData.description}
      title={pageMetaData.title}
      type="ecom"
      keywords={pageMetaData.keywords}
      analyticData={{ name: 'Product Story', properties: { product_category: 'invisible_braces' } }}
      headerCategory="Invisible braces"
      pageUrl="invisible-braces"
      pageEnabledMarkets={[]}
      customEvent={customEventParam[country] && customEventParam[country].type2}
    >
      <Head>
        <link rel="stylesheet" href="/vendor/slick/slick.min.css" />
        <link rel="stylesheet" href="/vendor/slick/slick-theme.min.css" defer={true} />
      </Head>
      {alignerLandingPageCountries.includes(country) ? <RestrictedPageLoader />
        : (
          <main className="invisible-braces-category-page zenyum-product-page">
            {configData?.loaded ? (
              <section
                data-gumlet="false"
                className={`invisible-braces-category-page__banner mobile-${bannerMobile.textTheme}
                  desktop-${bannerDesktop.textTheme}`}
                style={{ backgroundImage: `url(${isMobile ? bannerMobile?.bannerUrl : bannerDesktop?.bannerUrl})` }}
              >
                <div>
                  <h1 dangerouslySetInnerHTML={{ __html: bannerDesktop.header }} />
                  <p dangerouslySetInnerHTML={{ __html: bannerDesktop.body }} />
                  <div className="homenew-buttonbox">
                    {bannerDesktop.cta1 && (
                      <a
                        href={`${obtBaseUrl}${country}-${lang}/intro/${utmParams}`}
                        className="web-btn web-btn--fill"
                        onClick={() => { freeSmileAssessmentClicked(countryMap[country], 'Top Banner'); }}
                      >
                        {bannerDesktop.cta1}
                      </a>
                    )}
                    {bannerDesktop.cta2 && (country === 'tw'
                      ? (
                        <Slink to="steps" spy={true} smooth={true} offset={isMobile ? -95 : -110} duration={500}>
                          <a
                            className="learn-more"
                            onClick={() => { seeHowItWorksClicked(countryMap[country], 'Top Banner'); }}
                            role="presentation"
                          >
                            {bannerDesktop.cta2}
                          </a>
                        </Slink>)
                      : (
                        <Slink to="steps" spy={true} smooth={true} offset={isMobile ? -95 : -110} duration={500}>
                          <a
                            className="learn-more"
                            onClick={() => { seeHowItWorksClicked(countryMap[country], 'Top Banner'); }}
                            role="presentation"
                          >
                            {bannerDesktop.cta2}
                          </a>
                        </Slink>
                      ))}
                  </div>
                </div>
              </section>
            ) : (
              <div className="banner-skeleton-loading">
                <div className="banner-content" />
                <div className="banner-sub-content" />
              </div>
            )}

            <div className="cds--grid">
              <section className="aligner-sponsor-section">
                <div className="review-wrapper">
                  <div className="google-review">
                    <img src="/img/updated/homepage/google.png" data-gumlet="false" alt="google_icon" />
                    <p
                      data-lokalise=""
                      data-key="aligner_category_page::aligner_sponsor_section::review_count"
                    >
                      {alignerPage.aligner_sponsor_section.review_count}
                    </p>
                  </div>
                  <div className="star-rating">
                    <p
                      data-lokalise=""
                      data-key="aligner_category_page::aligner_sponsor_section::rating_points"
                    >
                      {alignerPage.aligner_sponsor_section.rating_points}
                    </p>
                    <img src="/img/updated/homepage/rating_icons.png" data-gumlet="false" alt="Star-rating" />
                  </div>
                </div>
                <Slider {...sponsorSlider} className="homenew-layout-slider ">
                  {sponsorCompanyList && sponsorCompanyList[country].map((key) => (
                    <div className="slide-wrapper" key={key.title}>
                      <img data-gumlet="false" src={key.image_url} alt={key.title} />
                    </div>
                  ))}
                </Slider>
              </section>
            </div>
            {!animatedIBBannerEnabledMarkets.includes(country) && (
              <section
                className="video-play-section image-flex"
                style={{ backgroundImage: `url('/img/updated/homepage/Aligners_Banner${isMobile
                  ? '_Mobile' : '_Desktop'}.jpg')` }}
              >
                <div className="image-text">
                  <h3
                    className="align-head"
                    data-lokalise=""
                    data-key="aligner_category_page::video_play_section::section_heading"
                  >
                    {alignerPage.video_play_section.section_heading}
                  </h3>
                  <p
                    className={(country !== 'jp' && country !== 'th') ? 'align' : 'align-jp'}
                    data-lokalise=""
                    data-key="aligner_category_page::video_play_section::section_description"
                  >
                    {alignerPage.video_play_section.section_description}
                  </p>
                  <div
                    className={(country !== 'jp' && country !== 'th')
                      ? 'inner-flex end-text' : 'inner-flex end-text-jp'}
                  >
                    <a
                      className="d-inline-block"
                      data-lokalise=""
                      data-key="aligner_category_page::video_play_section::watch_the_video"
                      onClick={videosection}
                      aria-hidden="true"
                    >
                      {alignerPage.video_play_section.watch_the_video}
                    </a>
                    <img
                      onClick={videosection}
                      alt="playbutton"
                      role="presentation"
                      data-gumlet="false"
                      src="/img/updated/homepage/playbutton.svg"
                    />
                    <a
                      data-lokalise=""
                      data-key="aligner_category_page::video_play_section::get_free_assessment"
                      onClick={() => {
                        getFreeAssessmentClicked(countryMap[country],
                          'Smile transformations made easy');
                      }}
                      href={`${obtBaseUrl}${country}-${lang}/intro/${utmParams}`}
                    >
                      {alignerPage.video_play_section.get_free_assessment}
                    </a>
                  </div>
                </div>
              </section>
            )}
            {animatedIBBannerEnabledMarkets.includes(country) && (
              <section className="aligner-animated-section">
                <div className="animated-container">
                  <div className="left-col">
                    <img src="/img/updated/banner/animated-teeth-1.gif" alt="animated tooth" data-gumlet="false" />
                  </div>
                  <div className="right-col">
                    <h2>
                      <span className={lang === 'zh' ? 'highlight-text' : ''}>
                        {alignerPage.animated_section.heading_1}
                      </span>
                  &nbsp;
                      <span
                        className={`${lang === 'en' || lang === 'vi' ? 'highlight-text' : ''} 
                  ${lang !== 'vi' ? 'text-align-others' : ''}`}
                      >
                        {alignerPage.animated_section.heading_2}
                      </span>
                    </h2>
                    <p dangerouslySetInnerHTML={{ __html: alignerPage.animated_section.sub_heading }} />
                    <a
                      href={`${obtBaseUrl}${country}-${lang}/intro/${utmParams}`}
                      className="web-btn web-btn--fill"
                      onClick={() => { freeSmileAssessmentClicked(countryMap[country], 'Animated Banner'); }}
                    >
                      {alignerPage.animated_section.cta_1}

                    </a>
                    <a
                      onClick={videosection}
                      role="presentation"
                      className="btn video-play-btn"
                    >
                      {alignerPage.animated_section.cta_2}

                    </a>
                  </div>
                  <div className="iso-logo-container">
                    <img src="/img/bsi_white.svg" alt="ISO Logo" data-gumlet="false" />
                  </div>
                </div>
              </section>
            )}
            <section className="aligner-assesment-detail-section" id="steps">
              <div className="detail-wrapper">
                <h1
                  data-lokalise=""
                  data-key="aligner_category_page::aligner_assesment_detail_section::section_heading"
                >
                  {alignerPage.aligner_assesment_detail_section.section_heading}
                </h1>
                <p
                  data-lokalise=""
                  data-key="aligner_category_page::aligner_assesment_detail_section::section_description"
                >
                  {alignerPage.aligner_assesment_detail_section.section_description}
                </p>
              </div>
              <div className="card-wrapper">
                <Slider {...cardSlider} className="steps-card-slider ">
                  {Object.entries(alignerPage.aligner_assesment_detail_section.aligner_steps_card_section).map(
                    ([key, value], index) => (
                      <div className="slide-wrapper" key={`${index + 1}+1`}>
                        <AlignerPageCard key={key} item={value} />
                      </div>
                    )
                  )}
                </Slider>
              </div>
              <div className="button-wrapper">
                <a
                  href={`${obtBaseUrl}${country}-${lang}/intro/${utmParams}`}
                  className="btn web-btn eligible-btn web-btn--fill"
                  data-lokalise=""
                  data-key="aligner_category_page::aligner_assesment_detail_section::am_i_eligible"
                  onClick={() => {
                    eligibilityClicked(countryMap[country],
                      'A confident smile can change your story');
                  }}
                >
                  {alignerPage.aligner_assesment_detail_section.am_i_eligible}
                </a>
                <Slink to="payment" spy={true} smooth={true} offset={isMobile ? -95 : -110} duration={500}>
                  <a
                    className="steps-learn-more"
                    data-lokalise=""
                    data-key="aligner_category_page::aligner_assesment_detail_section::learn_about_pricing"
                    role="presentation"
                    onClick={() => {
                      learnAboutPricingClicked(countryMap[country], 'A confident smile can change your story');
                    }}
                  >
                    {alignerPage.aligner_assesment_detail_section.learn_about_pricing}
                  </a>
                </Slink>
              </div>
            </section>

            <section className="homenew-layout__content aligner-right-section" id="treatmentplans">
              <div className="cds--grid">
                <div className="section-title text-align-center">
                  <h2
                    data-lokalise=""
                    data-key="aligner_category_page::aligner_comparison::section_heading"
                    dangerouslySetInnerHTML={{ __html: alignerPage.aligner_comparison.section_heading }}
                  />
                  <p
                    data-lokalise=""
                    data-key="aligner_category_page::aligner_comparison::section_description"
                    dangerouslySetInnerHTML={{ __html: alignerPage.aligner_comparison.section_description }}
                  />
                </div>
                <table className="cds--offset-lg-3 cds--col-lg-10">
                  <tbody>
                    <tr>
                      <th
                        data-lokalise=""
                        data-key="aligner_category_page::aligner_comparison::zenyum_clear::row_heading"
                      >
                        {alignerPage.aligner_comparison.zenyum_clear.row_heading}
                      </th>
                      <th
                        data-lokalise=""
                        data-key="aligner_category_page::aligner_comparison::zenyum_clear_plus::row_heading"
                      >
                        {alignerPage.aligner_comparison.zenyum_clear_plus.row_heading}
                      </th>
                      {zenyumClearExtraEnabledMarkets.includes(country) && (
                        <th
                          data-lokalise=""
                          data-key="aligner_category_page::aligner_comparison::zenyumclear_tm_extra::row_heading"
                        >
                          {alignerPage.aligner_comparison.zenyumclear_tm_extra.row_heading}
                        </th>
                      )}
                    </tr>
                    {alignerPage.aligner_comparison.zenyum_clear.data
                && alignerPage.aligner_comparison.zenyum_clear.data.length > 0
                && [...Array(rightArr).keys()].map((item, index) => (
                  <tr key={`${index + 1}+1`}>
                    <td
                      data-key={`aligner_category_page::aligner_comparison::zenyum_clear::data::${index}::feature`}
                      data-lokalise=""
                      className={index === 3 || index === 4 ? 'column-content' : ''}
                    >
                      {alignerPage.aligner_comparison.zenyum_clear.data[item].feature}
                      {index === 3 && (
                      <Popover id={index}>
                        <p
                          data-key="aligner_category_page::aligner_comparison::zenyum_clear::duration_content"
                          data-lokalise=""
                        >
                          {alignerPage.aligner_comparison.zenyum_clear.duration_content}
                        </p>
                      </Popover>
                      )}
                      {index === 4 && (
                      <Popover id={index}>
                        <p
                          data-key="aligner_category_page::aligner_comparison::zenyum_clear::attachment_content"
                          data-lokalise=""
                        >
                          {alignerPage.aligner_comparison.zenyum_clear.attachment_content}
                        </p>
                      </Popover>
                      )}
                    </td>
                    <td
                      data-key={`aligner_category_page::aligner_comparison::zenyum_clear_plus::data::${index}::feature`}
                      data-lokalise=""
                    >
                      {alignerPage.aligner_comparison.zenyum_clear_plus.data[item].feature}
                    </td>
                    {zenyumClearExtraEnabledMarkets.includes(country) && (
                    <td
                      data-key={`aligner_category_page::aligner_comparison::zenyumclear_tm_extra::data::${index}::feature`}
                      data-lokalise=""
                    >
                      {alignerPage.aligner_comparison.zenyumclear_tm_extra.data[item].feature}

                    </td>)}
                  </tr>
                ))}
                  </tbody>
                </table>
                <p
                  className="cds--offset-lg-3 cds--col-lg-10 p-0"
                  data-lokalise=""
                  data-key="aligner_category_page::aligner_comparison::price_disclaimer"
                >
                  {alignerPage.aligner_comparison.price_disclaimer}
                </p>
                <div className="smile-btn-flex button-wrapper">
                  <a
                    href={`${obtBaseUrl}${country}-${lang}/intro/${utmParams}`}
                    className="btn web-btn eligible-btn web-btn--fill"
                    data-lokalise=""
                    data-key="aligner_category_page::aligner_comparison::treatment_button"
                    onClick={() => {
                      treatmentPlanClicked(countryMap[country], 'Which Zenyum treatment is right for you');
                    }}
                  >
                    {alignerPage.aligner_comparison.smile_treatment}
                  </a>
                </div>
              </div>
            </section>

            <section className="payityourway" id="payment">
              <h1
                data-lokalise=""
                data-key="aligner_category_page::pay_it_your_way::section_heading"
              >
                {alignerPage.pay_it_your_way.section_heading}
              </h1>
              <p
                data-lokalise=""
                data-key="aligner_category_page::pay_it_your_way::section_description"
              >
                {alignerPage.pay_it_your_way.section_description}
              </p>
              <div className="payment-modes">
                <span
                  role="presentation"
                  onClick={() => { paymentSlider.current.slickPrev(); }}
                  className={activeSlide === 0 ? 'active' : ''}
                  data-lokalise=""
                  data-key="aligner_category_page::pay_it_your_way::one_time_payment"
                >
                  {alignerPage.pay_it_your_way.one_time_payment}
                </span>
                <span
                  role="presentation"
                  onClick={() => { paymentSlider.current.slickNext(); }}
                  className={activeSlide === 1 ? 'active' : ''}
                  data-lokalise=""
                  data-key="aligner_category_page::pay_it_your_way::monthly_payment"
                >
                  {alignerPage.pay_it_your_way.monthly_payment}
                </span>
              </div>
              <div className="paycards-container">
                <Slider {...paymentsSliderSettings} ref={paymentSlider}>
                  <div className="paycard-1">
                    <h1
                      data-lokalise=""
                      data-key="aligner_category_page::pay_it_your_way::one_time_payment"
                    >
                      {alignerPage.pay_it_your_way.one_time_payment}
                    </h1>
                    <div className="paycard-section-1">
                      <h2
                        data-lokalise=""
                        data-key="aligner_category_page::pay_it_your_way::zenyumclear"
                      >
                        {alignerPage.pay_it_your_way.zenyumclear}
                      </h2>
                      <h3
                        data-lokalise=""
                        data-key="aligner_category_page::pay_it_your_way::pricing_onetime_one"
                      >
                        {alignerPage.pay_it_your_way.pricing_onetime_one}

                      </h3>
                      <p
                        data-lokalise=""
                        data-key="aligner_category_page::pay_it_your_way::for_all_your_aligner_sets"
                      >
                        {alignerPage.pay_it_your_way.for_all_your_aligner_sets}

                      </p>
                    </div>
                    <div className="paycard-section-2">
                      <hr />
                      <h2
                        data-lokalise=""
                        data-key="aligner_category_page::pay_it_your_way::zenyumclear_plus"
                      >
                        {alignerPage.pay_it_your_way.zenyumclear_plus}

                      </h2>
                      <h3
                        data-lokalise=""
                        data-key="aligner_category_page::pay_it_your_way::pricing_onetime_two"
                      >
                        {alignerPage.pay_it_your_way.pricing_onetime_two}

                      </h3>
                      <p
                        data-lokalise=""
                        data-key="aligner_category_page::pay_it_your_way::based_on_complexity"
                      >
                        {alignerPage.pay_it_your_way.based_on_complexity}

                      </p>
                    </div>
                    {
                  zenyumClearExtraEnabledMarkets.includes(country) && (
                    <div className="paycard-section-3">
                      <hr />
                      <h2
                        data-lokalise=""
                        data-key="aligner_category_page::pay_it_your_way::zenyum_clear_extra"
                      >
                        {alignerPage.pay_it_your_way.zenyum_clear_extra}

                      </h2>
                      <h3
                        data-lokalise=""
                        data-key="aligner_category_page::pay_it_your_way::pricing_onetime_three"
                      >
                        {alignerPage.pay_it_your_way.pricing_onetime_three}
                      </h3>
                      <p
                        data-lokalise=""
                        data-key="aligner_category_page::pay_it_your_way::zenyum_clear_extra_one_time_content"
                      >
                        {alignerPage.pay_it_your_way.zenyum_clear_extra_one_time_content}
                      </p>
                    </div>
                  )
                }
                    <div className="button-holder" />
                    <a
                      href={`${obtBaseUrl}${country}-${lang}/intro/${utmParams}`}
                      className="web-btn btn web-btn--fill"
                      data-lokalise=""
                      data-key="aligner_category_page::banner_section::free_assessment_btn"
                      onClick={() => { startFreeAssessmentClicked(countryMap[country], 'Pay it your way'); }}
                    >
                      {alignerPage.pay_it_your_way.start_free_assessment}
                    </a>
                  </div>

                  <div className="paycard-2">
                    <h1
                      data-lokalise=""
                      data-key="aligner_category_page::pay_it_your_way::monthly_payment"
                    >
                      {alignerPage.pay_it_your_way.monthly_payment}

                    </h1>
                    <div className="paycard-section-1">
                      <h2
                        data-lokalise=""
                        data-key="aligner_category_page::pay_it_your_way::zenyumclear"
                      >
                        {alignerPage.pay_it_your_way.zenyumclear}

                      </h2>
                      <h3
                        data-lokalise=""
                        data-key="aligner_category_page::pay_it_your_way::pricing_monthly_one"
                      >
                        {(country === 'sg' || country === 'my') && (
                          <span
                            data-lokalise=""
                            data-key="aligner_category_page::pay_it_your_way::from"
                          >
                            {alignerPage.pay_it_your_way.from}
                      &nbsp;
                          </span>
                        )}
                        {alignerPage.pay_it_your_way.pricing_monthly_one}
                        <span
                          data-lokalise=""
                          data-key="aligner_category_page::pay_it_your_way::permonth"
                        >
                          {alignerPage.pay_it_your_way.permonth}

                        </span>
                      </h3>
                      <p
                        data-lokalise=""
                        data-key="aligner_category_page::pay_it_your_way::clear_monthly_interest_free_payments"
                        dangerouslySetInnerHTML={
                      { __html: alignerPage.pay_it_your_way.clear_monthly_interest_free_payments }
                    }
                      />
                    </div>
                    <div className="paycard-section-2">
                      <hr />
                      <h2
                        data-lokalise=""
                        data-key="aligner_category_page::pay_it_your_way::zenyumclear_plus"
                      >
                        {alignerPage.pay_it_your_way.zenyumclear_plus}
                      </h2>
                      <h3
                        data-lokalise=""
                        data-key="aligner_category_page::pay_it_your_way::pricing_monthly_two"
                      >
                        {(country === 'sg' || country === 'my') && (
                          <span
                            data-lokalise=""
                            data-key="aligner_category_page::pay_it_your_way::from"
                          >
                            {alignerPage.pay_it_your_way.from}
                      &nbsp;
                          </span>
                        )}
                        {alignerPage.pay_it_your_way.pricing_monthly_two}
                        <span
                          data-lokalise=""
                          data-key="aligner_category_page::pay_it_your_way::permonth"
                        >
                          {alignerPage.pay_it_your_way.permonth}

                        </span>
                      </h3>
                      <p
                        data-lokalise=""
                        data-key="aligner_category_page::pay_it_your_way::six_monthly_interest_free_payments"
                        dangerouslySetInnerHTML={{ __html: alignerPage.pay_it_your_way.six_monthly_interest_free_payments }}
                      />
                    </div>
                    {
                  zenyumClearExtraEnabledMarkets.includes(country) && (
                    <div className="paycard-section-3">
                      <hr />
                      <h2
                        data-lokalise=""
                        data-key="aligner_category_page::pay_it_your_way::zenyum_clear_extra"
                      >
                        {alignerPage.pay_it_your_way.zenyum_clear_extra}

                      </h2>
                      <h3
                        data-lokalise=""
                        data-key="aligner_category_page::pay_it_your_way::pricing_monthly_three"
                      >
                        {(country === 'sg' || country === 'my') && (
                        <span
                          data-lokalise=""
                          data-key="aligner_category_page::pay_it_your_way::from"
                        >
                          {alignerPage.pay_it_your_way.from}
                      &nbsp;
                        </span>
                        )}
                        {alignerPage.pay_it_your_way.pricing_monthly_three}
                        <span
                          data-lokalise=""
                          data-key="aligner_category_page::pay_it_your_way::permonth"
                        >
                          {alignerPage.pay_it_your_way.permonth}
                        </span>
                      </h3>
                      <p
                        data-lokalise=""
                        data-key="aligner_category_page::pay_it_your_way::zenyum_clear_extra_monthly_content"
                        dangerouslySetInnerHTML={{ __html: alignerPage.pay_it_your_way.zenyum_clear_extra_monthly_content }}
                      />
                    </div>
                  )
                }
                    <div className="button-holder" />
                    <a
                      href={`${obtBaseUrl}${country}-${lang}/intro/${utmParams}`}
                      className="web-btn btn web-btn--fill"
                      data-lokalise=""
                      data-key="aligner_category_page::pay_it_your_way::start_free_assessment"
                      onClick={() => { startFreeAssessmentClicked(countryMap[country], 'Pay it your way'); }}
                    >
                      {alignerPage.pay_it_your_way.start_free_assessment}
                    </a>
                  </div>
                </Slider>
              </div>
              <div className="bottom-wrapper">
                <ul>
                  <li
                    data-lokalise=""
                    data-key="aligner_category_page::pay_it_your_way::in_app_treatment_monitoring"
                  >
                    {alignerPage.pay_it_your_way.in_app_treatment_monitoring}

                  </li>
                  <li
                    data-lokalise=""
                    data-key="aligner_category_page::pay_it_your_way::full_set_of_zenyum_invisible_braces"
                  >
                    {alignerPage.pay_it_your_way.full_set_of_zenyum_invisible_braces}

                  </li>
                  <li
                    data-lokalise=""
                    data-key="aligner_category_page::pay_it_your_way::dedicated_customer_care"
                  >
                    {alignerPage.pay_it_your_way.dedicated_customer_care}

                  </li>
                  <li
                    data-lokalise=""
                    data-key="aligner_category_page::pay_it_your_way::free_smile_assessment"
                  >
                    {alignerPage.pay_it_your_way.free_smile_assessment}

                  </li>
                </ul>
              </div>
              <div className="sponsor-section">
                {paymentMethodMap[country].map((item, index) => (
                  <div className="slider-img-wrapper" key={`${index + 1}+1`}>
                    <img src={`/img/updated/homepage/payyourway/${item}.png`} alt={item} data-gumlet="false" />
                  </div>
                ))}
              </div>
              {((country === 'sg' || country === 'my' || country === 'jp')
              && (!!alignerPage.pay_it_your_way.price_disclaimer.length)) && (
              <div className="price-disclaimer">
                <p
                  data-lokalise=""
                  data-key="key::aligner_category_page::pay_it_your_way::price_disclaimer"
                >
                  {alignerPage.pay_it_your_way.price_disclaimer}
                </p>
              </div>
              )}
            </section>
            {country !== 'tw' && (
              <section className="before-after-section" id="results">
                <div className="cds--grid">
                  <h3>{alignerPage.before_after_section.heading}</h3>
                  <div className="before-after-section-wrapper">
                    {(country !== 'vn' ? beforeAfterImages : beforeAfterImagesVn).map((imageData) => (
                      (!isMobile || imageData.mobile) && (
                      <div className="ba-wrapper" key={imageData.name}>
                        <BeforeAfterImage imageData={imageData} />
                      </div>
                      )))}
                  </div>
                </div>
              </section>
            )}

            <section className="section-faq section-clinics">
              <div className="cds--grid">
                <div className="faq-sections-wrapper">
                  <h2
                    className="clinics-section-heading"
                    data-lokalise=""
                    data-key="aligner_category_page::clinic_locations_section::section_heading"
                  >
                    {alignerPage?.clinic_locations_section?.section_heading}
                  </h2>
                  <p
                    data-lokalise=""
                    data-key="aligner_category_page::clinic_locations_section::section_subheading"
                  >
                    {alignerPage?.clinic_locations_section?.section_subheading}
                  </p>
                  <section>
                    {multilangcountries.includes(country) ? jpHkClinicLocations[country]?.map((item) => (

                      <div className="faq-collapse-wrapper clinic-locations-wrapper" key={item}>
                        <ClinicLocationsCollapse
                          title={item.location[lang]}
                          content={item.areas[lang]}
                        />
                      </div>
                    ))
                      : clinicLocations[country]?.map((item) => (

                        <div className="faq-collapse-wrapper clinic-locations-wrapper" key={item.location}>
                          <ClinicLocationsCollapse
                            title={item.location}
                            content={item.areas}
                          />
                        </div>
                      ))}
                  </section>
                </div>
              </div>
            </section>

            <section className="section-faq aligner-faq">
              <div className="cds--grid">
                <div className="faq-sections-wrapper">
                  <h2
                    data-lokalise=""
                    data-key="aligner_category_page::faq_heading"
                    className="faq-heading"
                  >
                    {alignerPage.faq_heading}
                  </h2>
                  <section className="faq-section">
                    {faqData[0].data && faqData[0].data.length > 0 && faqData[0].data.map((row, iKey) => (
                      row.question && (
                        <div className="faq-collapse-wrapper" key={row.question}>
                          <Collapse
                            Lkey={`faqs::faq_a::data::${iKey}`}
                            title={row.question}
                            content={row.answer}
                          />
                        </div>
                      )
                    ))}
                  </section>
                </div>
              </div>
            </section>
            <section className="aligner-footer-revamp">
              <Container
                data-lokalise=""
                data-key="aligner_category_page::aligner_footer"
                dangerouslySetInnerHTML={{ __html: alignerPage.aligner_footer }}
              />
            </section>
            <Modal
              isOpen={modal}
              toggle={toggle}
              className="video-popup aligner-video-popup"
            >
              <a
                className="aligner-video-close"
                onClick={toggle}
                aria-hidden="true"
              >
                <img src="/img/close-bold.svg" alt="Close popup" />
              </a>
              <ModalBody
                {...animatedIBBannerEnabledMarkets.includes(country) && { className: 'iframe-video' }}
              >
                <div>
                  {!animatedIBBannerEnabledMarkets.includes(country)
                    ? (
                      <video controls={true}>
                        <source
                          src="/img/updated/homepage/desktop_Aligners_Newvideo.mp4"
                          type="video/mp4"
                        />
                      </video>
                    )
                    : <iframe
                        src={animatedIBBannerCta2Links[i18n.activeLocale]}
                        frameBorder="0"
                        title="video"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;"
                        allowFullScreen={true}
                        width="100%"
                    />}
                </div>
              </ModalBody>
            </Modal>
          </main>
        )}
    </Layout>
  );
};

export async function getStaticProps({ params }) {
  const lngDict = {};
  const pageId = PAGEID.INVISIBLE_BRACES;
  const keys = getTranslationKeys(pageId);
  const { default: lngDictAll = {} } = await import(
    `../../locales/${contentLanguageMap[params.lng]}.json`
  );
  keys.forEach((data) => {
    lngDict[data] = lngDictAll[data];
  });
  return {
    props: { lng: params.lng, lngDict, pageId }
  };
}

export async function getStaticPaths() {
  return {
    paths: languages.map((l) => ({ params: { lng: l } })),
    fallback: false
  };
}

export default InvisibleBraces;
